const CAMPAIGN = {
  title: {
    hint: 'l10n.CAMPAIGN_NAME_HINT',
    label: 'l10n.NAME_CAMPAIGN',
    required: true,
    requiredIcon: true,
  },
  // dates: {
  //   inline: 2,
  //   label: 'l10n.PERIOD_CAMPAIGN',
  //   placeholder: 'l10n.CHOOSE_DATE',
  //   range: true,
  //   type: 'date',
  // },
  // domains: {
  //   disabled: false,
  //   inline: 2,
  //   label: 'l10n.DOMAINS',
  //   placeholder: 'l10n.DOMAINS_PLACEHOLDER',
  //   type: 'list',
  // },
};

const CAMPAIGN_WIDGET = {
  destination: {
    inline: 2,
    hint: 'l10n.DESTINATION_HINT',
    label: 'l10n.DESTINATION',
    type: 'searcher',
    dataSource: [],
    placeholder: 'l10n.SEARCH_DESTINATION',
  },
  category: {
    inline: 2,
    label: 'l10n.CATEGORY',
    type: 'select',
    dataSource: [],
    disabled: true,
  },
};

const DATE_RANGE = {
  period: {
    inline: 2,
    label: 'l10n.PERIOD',
    type: 'select',
    dataSource: 'l10n.PERIOD_DATASOURCE',
  },
  dates: {
    disabledPast: false,
    inline: 2,
    label: 'l10n.DATES',
    placeholder: 'l10n.CHOOSE_DATE',
    range: true,
    type: 'date',
  },
};

const PROFILE = {
  id: {
    label: 'l10n.AFFILIATE_ID',
    disabled: true,
    inline: 2,
  },
  email: {
    label: 'e-mail',
    disabled: true,
    inline: 2,
  },
  firstName: {
    inline: 2,
    label: 'l10n.FIRST_NAME',
    required: true,
    requiredIcon: true,
  },
  lastName: {
    inline: 2,
    label: 'l10n.LAST_NAME',
    required: true,
    requiredIcon: true,
  },
  phone: {
    inline: 2,
    countryCode: true,
    keyboard: 'phone-pad',
    label: 'l10n.PHONE',
  },

  document: {
    title: 'l10n.DOCUMENT',
    attributes: {
      type: {
        label: 'l10n.TYPE', inline: 2, type: 'select', dataSource: ['l10n.PASSPORT', 'l10n.IDCARD'],
      },
      value: { label: 'l10n.NUMBER', inline: 2 },
    },
  },

  payment: {
    title: 'l10n.PAYMENT',
    attributes: {
      accountHolder: { label: 'l10n.ACCOUNT_HOLDER', inline: 2 },
      bankName: { label: 'l10n.BANK_NAME', inline: 2 },
      iban: { label: 'IBAN', inline: 2 },
      swiftBic: { label: 'SWIFT/BIC', inline: 4 },
    },
  },

  invoiceAddress: {
    title: 'l10n.INVOICE_ADDRESS',
    attributes: {
      title: {
        label: 'l10n.FULL_NAME', required: true, requiredIcon: true,
      },
      street: {
        label: 'l10n.STREET', required: true, requiredIcon: true,
      },
      zip: {
        label: 'l10n.ZIP', inline: 3, required: true, requiredIcon: true,
      },
      city: {
        label: 'l10n.CITY', inline: 3, required: true, requiredIcon: true,
      },
      country: {
        label: 'l10n.COUNTRY', inline: 3, required: true, requiredIcon: true,
      },
    },
  },
};

const SIGN_IN = {
  email: { type: 'email', label: 'e-mail', required: true },
  password: { label: 'l10n.PASSWORD', required: true, secureTextEntry: true },
};

const SIGN_UP = {
  email: { type: 'email', label: 'e-mail', required: true },
  password: { label: 'l10n.PASSWORD', required: true, secureTextEntry: true },
  repassword: { label: 'l10n.PASSWORD_REPEAT', required: true, secureTextEntry: true },
};

const STATS = {
  period: {
    inline: 2,
    label: 'l10n.PERIOD',
    type: 'select',
    dataSource: 'l10n.PERIOD_DATASOURCE',
  },
  dates: {
    disabledPast: false,
    inline: 2,
    label: 'l10n.DATES',
    placeholder: 'l10n.CHOOSE_DATE',
    range: true,
    type: 'date',
  },
};

const TABLE_BOOKINGS = {
  experience: { label: 'l10n.EXPERIENCE', style: { minWidth: '30%' } },
  campaign: { label: 'l10n.CAMPAIGN', style: { minWidth: '20%' } },
  createdAt: { label: 'l10n.DATE_CREATED' },
  usedAt: { label: 'l10n.DATE_USED' },
  fee: { label: 'l10n.FEE', type: 'price', style: { alignItems: 'center' } },
};

const TABLE_BOOKING_EVENTS = {
  type: { label: 'l10n.EVENT' },
  createdAt: { label: 'l10n.DATE' },
};

const TABLE_CAMPAIGNS = {
  title: { label: 'l10n.NAME', style: { minWidth: '30%' } },
  type: { label: 'l10n.TYPE' },
  bookings: { label: 'l10n.BOOKINGS', type: 'number', style: { alignItems: 'center' } },
  clicks: { type: 'number', style: { alignItems: 'center' } },
  conversionRate: { label: 'l10n.CONVERSION', type: 'number', style: { alignItems: 'center' } },
  fee: { type: 'price', label: 'l10n.FEE', style: { alignItems: 'center' } },
};

const TABLE_INVOICES = {
  number: { label: 'l10n.NUMBER', style: { minWidth: '30%' } },
  invoicedAt: { label: 'l10n.INVOICED' },
  createdAt: { label: 'l10n.CREATED' },
  total: { label: 'l10n.TOTAL', type: 'price', style: { alignItems: 'center' } },
};

const TABLE_STATS = {
  date: { label: 'l10n.DATE', style: { minWidth: '30%' } },
  clicks: { style: { alignItems: 'center' } },
  conversionRate: { label: 'conversion', style: { alignItems: 'center' } },
  fee: { label: 'l10n.FEE', type: 'price', style: { alignItems: 'center' } },
};

export default {
  CAMPAIGN,
  CAMPAIGN_WIDGET,
  DATE_RANGE,
  SIGN_IN,
  SIGN_UP,
  STATS,
  PROFILE,
  TABLE_BOOKINGS,
  TABLE_BOOKING_EVENTS,
  TABLE_CAMPAIGNS,
  TABLE_INVOICES,
  TABLE_STATS,
};
